function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m3.25 3.1372h19.5v2h-19.5v-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.9585 7.4436h14.083v2h-14.083v-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.041 11.75h-14.083v2h14.083v-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.9585 16.056h14.083v2h-14.083v-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.75 20.363h-19.5v2h19.5v-2z"
}));
function SvgCategorialScales(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "static/2.5.1/media/categorialScales.8c832177.svg";
export { SvgCategorialScales as ReactComponent };